import { Tokens } from '../tokens';

const kebab = (key: string): string =>
  key.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

export function tokensToCssVars(tokens: Tokens): Record<string, string> {
  const vars: Record<string, string> = {};

  Object.entries(tokens.colors).forEach(([k, v]) => {
    vars[`--color-${kebab(k)}`] = v;
  });
  Object.entries(tokens.shadows).forEach(([k, v]) => {
    vars[`--shadow-${kebab(k)}`] = v;
  });
  Object.entries(tokens.spacing).forEach(([k, v]) => {
    vars[`--space-${k}`] = v;
  });
  Object.entries(tokens.radii).forEach(([k, v]) => {
    vars[`--radius-${kebab(k)}`] = v;
  });
  Object.entries(tokens.typography.size).forEach(([k, v]) => {
    vars[`--font-size-${k}`] = v;
  });
  Object.entries(tokens.typography.weight).forEach(([k, v]) => {
    vars[`--font-weight-${kebab(k)}`] = String(v);
  });
  Object.entries(tokens.typography.lineHeight).forEach(([k, v]) => {
    vars[`--line-height-${k}`] = String(v);
  });
  vars['--font-sans'] = tokens.typography.fontFamilySans;
  vars['--font-display'] = tokens.typography.fontFamilyDisplay;
  vars['--font-mono'] = tokens.typography.fontFamilyMono;

  Object.entries(tokens.motion.duration).forEach(([k, v]) => {
    vars[`--duration-${k}`] = v;
  });
  Object.entries(tokens.motion.ease).forEach(([k, v]) => {
    vars[`--ease-${k}`] = v;
  });

  return vars;
}

export function applyCssVarsToRoot(tokens: Tokens, target?: HTMLElement): void {
  const el = target ?? document.documentElement;
  const vars = tokensToCssVars(tokens);
  Object.entries(vars).forEach(([k, v]) => {
    el.style.setProperty(k, v);
  });
  el.setAttribute('data-theme', tokens.mode);
  el.style.colorScheme = tokens.mode;
}
